
<section
  class="w-full flex flex-row justify-center bg-themeComponentBg-light service-area-text-outer-container"
  aria-labelledby="service-area-heading"
>
  <div class="flex flex-col gap-7 w-full max-w-1216 pt-3 mx-5 font-rubik">
    <h2 id="service-area-heading" class="service-area-h2 text-center" v-html="heading"></h2>
    <article v-html="contentHtml" class="service-area-p"></article>
  </div>
</section>
